// extracted by mini-css-extract-plugin
module.exports =  {"content":"_25d45facb5--content--oTCcM","footer-buttons":"_25d45facb5--footer-buttons--wKynG"};